import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, useReducedMotion } from 'framer-motion';
import PropTypes from 'prop-types';
import { useMenu } from '../../context/menu.context';
// Components
import { SideBarMenu } from '../side-nav-component/side-nav.component';
// Styled Components
import { Div, SideBarDiv } from './navigation.styles';

const sideBarAnimation = {
	initial: { opacity: 0, x: '-100%' },
	animate: { opacity: 1, x: 0, transition: { duration: 0.28, ease: 'easeOut' } },
	exit: { opacity: 0, x: '-100%', transition: { duration: 0.22, ease: 'easeIn' } },
};

const NavigationHamburger = ({ isOpen }) => {
	const { close } = useMenu();
	const reduceMotion = useReducedMotion();

	useEffect(() => {
		if (!isOpen) return undefined;

		const previousOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
		const handleKeyDown = (event) => {
			if (event.key === 'Escape') close();
      if (event.key === 'Tab') {
        const dialog = document.getElementById('site-navigation-menu');
        const items = [...(dialog?.querySelectorAll('a[href], button, summary, select, [tabindex="0"]') || [])].filter(item => item.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
		};
		window.addEventListener('keydown', handleKeyDown);

		return () => {
			document.body.style.overflow = previousOverflow;
			window.removeEventListener('keydown', handleKeyDown);
      document.querySelector('[aria-controls="site-navigation-menu"]')?.focus();
		};
	}, [close, isOpen]);

	return (
		<Div>
			{typeof document !== 'undefined' && createPortal(<AnimatePresence>
				{isOpen && (
					<SideBarDiv
						id="site-navigation-menu"
						role="dialog"
						aria-modal="true"
						aria-label="Site navigation"
						{...(reduceMotion ? { initial: false, animate: { opacity: 1, x: 0 }, exit: { opacity: 0, transition: { duration: 0 } } } : sideBarAnimation)}
					>
						<SideBarMenu />
					</SideBarDiv>
				)}
			</AnimatePresence>, document.body)}
		</Div>
	);
};

NavigationHamburger.propTypes = {
	isOpen: PropTypes.bool,
};

export default NavigationHamburger;
